// extracted by mini-css-extract-plugin
module.exports = {"body":"y2MmZs","frame":"TLAzVK","hidden":"_3y6hT6"};